import { getNodeFromString } from 'global/common/globalUtils';

export default class ModalManager {
	insertResponse(data, modalId) {
		this.setupResponseHtml(data);
		this.modalId = modalId;
		this.modalHtml = this.modalExists();

		if (this.modalHtml) {
			this.replaceModalContent();
		} else {
			this.addModal();
		}

		this.showModal();
	}

	setupResponseHtml(data) {
		this.responseHtml = getNodeFromString(data);
	}

	modalExists() {
		return document.getElementById(this.modalId);
	}

	replaceModalContent() {
		const responseChildNode = this.responseHtml.firstElementChild;

		this.modalHtml.replaceChild(
			responseChildNode,
			this.modalHtml.firstElementChild,
		);
	}

	addModal() {
		document.body.appendChild(this.responseHtml);

		this.modalHtml = this.modalExists();
	}

	showModal() {
		const { Modal } = window.od;
		const modalId = document.getElementById(this.modalId);

		this.modal = new Modal(modalId);
		this.modal.show();
		this.modalHtml = this.modalExists();
	}
}
